<template>
  <div class="blog-main-content">
    <BlogList class="right"/>
    <h1>Arcane Sanctuary (Terror Zone) Efficient Run Guide</h1>

    <h2>Route Planning</h2>
    <ul>
        <li><strong>1. Teleport to Arcane Sanctuary from town:</strong>
            <ul>
                <li>Since Arcane Sanctuary has a waypoint, all players can teleport directly from town without needing to run through other areas.</li>
            </ul>
        </li>
        <li><strong>2. Two Farming Methods:</strong></li>
        <ul>
            <li><strong>Standard Farming Method:</strong>
                <ul>
                    <li>Arcane Sanctuary has four paths, each with potential elite monster groups at the end. Splitting up the team to clear different paths improves efficiency.</li>
                    <li>Lightning-based builds perform exceptionally well here, as there are no lightning-immune monsters.</li>
                    <li>After clearing all monsters, create a new game and repeat to maximize experience gain.</li>
                </ul>
            </li>
            <li><strong>High-Efficiency Elite Monster Method:</strong>
                <ul>
                    <li>Only one of the four paths usually contains two elite monster groups, while the others have only one.</li>
                    <li>If you encounter a path with two elite monster groups, clear them quickly and then exit to create a new game. This method increases the number of elite monster kills per hour, significantly boosting experience gain.</li>
                    <li>If you find only one elite monster group on a path, continue clearing the other paths before creating a new game to avoid unnecessary downtime.</li>
                </ul>
            </li>
        </ul>
    </ul>

    <div id="slot-content_mpu" class="content-ad-mpu"/>

    <h2>Farming Strategy</h2>
    <ul>
        <li><strong>Utilize Terrain Advantages:</strong> The narrow pathways of Arcane Sanctuary favor ranged builds such as Lightning Sorceress and Trap Assassin, allowing them to attack from a distance without getting surrounded.</li>
        <li><strong>Target Ghost-Type Monsters for High Rune Drops:</strong> Ghosts have a higher rune drop rate than other monsters, making them a valuable farming target.</li>
        <li><strong>No Lightning-Immune Monsters:</strong> Any lightning-based build can efficiently clear this zone, with Lightning Sorceress and Javazon performing exceptionally well.</li>
        <li><strong>The High-Efficiency Elite Monster Method is Ideal for Players Above Level 96:</strong> Prioritizing paths with two elite monster groups and resetting the game once cleared maximizes experience gains.</li>
    </ul>
    <div>
      <img class="m-1 w-100" alt="Arcane Sanctuary run" src="@/assets/runs/arcane-sanctuary-run.png">
    </div>

    <h2>✅ Arcane Sanctuary Advantages</h2>
    <ul>
        <li><strong>Ghost-type monsters</strong> have an increased rune drop rate.</li>
        <li><strong>Narrow pathways</strong> provide a safe environment for ranged builds.</li>
        <li><strong>No lightning-immune monsters</strong>, making Lightning Sorceress and Javazon extremely effective.</li>
        <li><strong>The High-Efficiency Elite Monster Method</strong> significantly boosts experience gain for level 96+ players.</li>
    </ul>

    <h2>⚠️ Things to Watch Out For</h2>
    <ul>
        <li><strong>Complex terrain</strong> can make movement difficult for melee builds, reducing their effectiveness.</li>
        <li><strong>Ghosts can burn mana</strong> and ambush players, so squishy characters should be cautious.</li>
        <li><strong>The High-Efficiency Elite Monster Method</strong> requires good decision-making, as players need to quickly determine whether to reset the game.</li>
    </ul>

    <p>By utilizing the terrain effectively, prioritizing ghost-type enemies, and choosing the best farming method based on level, players can maximize experience gains and farming efficiency in Arcane Sanctuary!</p>

  </div>
</template>

<script>
import BlogList from '../BlogList.vue'

export default {
  name: 'ArcaneSanctuary',

  components: {
    BlogList,
  },
}
</script>